import {Injectable} from '@angular/core';
import {Observable, Subject} from 'rxjs';
import {CommonService} from "../../../shared/services/common.service";
import {FetchClientFilterModel} from "../models/fetch-client-filter.model";
import {
  FetchGroupStatusFilterModel
} from "../models/fetch-group-status-filter.model";
import {
  FetchMeasurementsFilterModel
} from "../models/fetch-measurements-filter.model";
import {FetchCoachesFilterModel} from "../models/fetch-coaches-filter.model";
import {GenerateGroupNameModel} from "../models/generate-group-name.model";
import {VerifyGroupNameModel} from "../models/verify-group-name.model";
import {AddGroupDetailsModel} from "../models/add-group-details.model";
import {UpdateGroupDetailsModel} from "../models/update-group-details.model";
import {FetchGroupDetailsModel} from "../models/fetch-group-details.model";
import {v1URL} from "../../../shared/constants/urls.constants";
import {FetchSessionListModel} from "../models/fetch-session-list.model";

@Injectable({
  providedIn: 'root',
})
export class GroupDetailsService {
  resetForm = new Subject<void>();
  disableForm = new Subject<void>();

  constructor(private commonServices: CommonService) {
  }

  fetchClientsFilter(payload: FetchClientFilterModel['request']): Observable<FetchClientFilterModel['response']> {
    const urlConfig = v1URL.filters.clients
    return this.commonServices.callAPI(urlConfig.method, urlConfig.url(payload));
  }

  fetchGroupStatusFilter(): Observable<FetchGroupStatusFilterModel['response']> {
    const urlConfig = v1URL.filters.groupStatus
    return this.commonServices.callAPI(urlConfig.method, urlConfig.url);
  }

  fetchMeasurementsFilter(): Observable<FetchMeasurementsFilterModel['response']> {
    const urlConfig = v1URL.filters.measurements
    return this.commonServices.callAPI(urlConfig.method, urlConfig.url);
  }

  fetchCoachesFilter(payload: FetchCoachesFilterModel['request']): Observable<FetchCoachesFilterModel['response']> {
    const urlConfig = v1URL.filters.coaches
    return this.commonServices.callAPI(urlConfig.method, urlConfig.url(payload));
  }

  generateGroupName(payload: GenerateGroupNameModel['request']): Observable<GenerateGroupNameModel['response']> {
    const urlConfig = v1URL.groupName.generate
    return this.commonServices.callAPI(urlConfig.method, urlConfig.url, payload);
  }

  verifyGroupName(payload: VerifyGroupNameModel['request']): Observable<VerifyGroupNameModel['response']> {
    const urlConfig = v1URL.groupName.verify
    return this.commonServices.callAPI(urlConfig.method, urlConfig.url, payload);
  }

  addGroupDetails(payload: AddGroupDetailsModel['request']): Observable<AddGroupDetailsModel['response']> {
    const urlConfig = v1URL.group.add
    return this.commonServices.callAPI(urlConfig.method, urlConfig.url, payload);
  }

  updateGroupDetails(payload: UpdateGroupDetailsModel['request']): Observable<UpdateGroupDetailsModel["response"]> {
    const urlConfig = v1URL.group.update
    return this.commonServices.callAPI(urlConfig.method, urlConfig.url(payload.groupId), payload);
  }

  fetchGroupDetails(payload: FetchGroupDetailsModel['request']): Observable<FetchGroupDetailsModel['response']> {
    const urlConfig = v1URL.group.details;
    return this.commonServices.callAPI(urlConfig.method, urlConfig.url(payload.groupId));
  }

  fetchGroupName(payload: FetchGroupDetailsModel['request']): Observable<FetchGroupDetailsModel['response']> {
    const urlConfig = v1URL.group.name;
    return this.commonServices.callAPI(urlConfig.method, urlConfig.url(payload.groupId));
  }

  createDuplicateGroup(payload: FetchGroupDetailsModel['request']): Observable<FetchGroupDetailsModel['response']> {
    const urlConfig = v1URL.group.details;
    return this.commonServices.callAPI(urlConfig.method, urlConfig.url(payload.groupId));
  }

  fetchSessionList(): Observable<FetchSessionListModel['response']> {
    const urlConfig = v1URL.filters.sessionList;
    return this.commonServices.callAPI(urlConfig.method, urlConfig.url);
  }

  createGroup(payload: any): Observable<any> {
    const urlConfig = v1URL.groups.create
    return this.commonServices.callAPI(urlConfig.method, urlConfig.url, payload);
  }

  fetchClientDetails(payload: any): Observable<any> {
    const urlConfig = v1URL.client.details
    return this.commonServices.callAPI(urlConfig.method, urlConfig.url(payload.clientId));
  }

  deleteGroup(payload: any): Observable<any> {
    const urlConfig = v1URL.groups.delete;
    const {refresh, ...params} = payload;
    return this.commonServices.callAPI(urlConfig.method, urlConfig.url(params), {isActive: payload.isActive});
  }
}
